<template>
    <div :class="classes">
        <div v-if="danger" :class="theme.stepDanger">
            <v-font-icon danger>
                warning
            </v-font-icon>
        </div>
        <div v-else :class="theme.stepCircle">
            <v-font-icon v-if="isComplete" :class="theme.stepCircleDone" white>done</v-font-icon>
            <span v-else>{{ step }}</span>
        </div>
        <div :class="theme.stepLabel">
            <slot>
                <div>
                    <v-text type="subheadling">Lorem Ipsum</v-text>
                </div>
                <v-text caption>Lorem Ipsum</v-text>
            </slot>
        </div>
    </div>
</template>

<script>
    import theme from './stepper.scss';

    export default {
        name: 'stepper-label',
        props: {
            step: Number,
            danger: Boolean,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        computed: {
            currentStep() {
                return this.$parent.step;
            },
            isComplete() {
                return this.currentStep > this.step;
            },
            classes() {
                return {
                    [this.theme.step]: true,
                    [this.theme.isInactive]: this.currentStep < this.step && !this.danger,
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// StepperLabel.vue?63ab1807